//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
let d=[[],[[["orientation"],"AddView",{},1,0],[[],"GetBaseView",{R_:{baseView:"ModelingView"}},0,0],[["orientation"],"SetBaseView",{},1,0],[["numViews","views"],"GetViews",{},0,0]],[]];
SPLM.ViewSet = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ViewSet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ViewSet.ViewOrientation = Object.freeze({
    "Top" : "Top", "Front" : "Front", "Right" : "Right", "Back" : "Back", "Bottom" : "Bottom", "Left" : "Left", "Isometric" : "Isometric", "Trimetric" : "Trimetric", "Dimetric" : "Dimetric"});

export default SPLM;